module.exports = __webpack_public_path__ + "img/newAct.006693c4.png";